import { PropertiesSettings, TagsSettings } from 'src/types/Main'
import hasFilterApplied from '../hasFilterApplied'
import FilteredProperties from './filteredProperties'
import FilteredTags from './filteredTags'
import FilteredSort from './filteredSort'
import FilteredPrice from './filteredPrice'
import applyFilters from '../applyFilters'
import React, { useCallback } from 'react'

interface Props {
  appliedTags: Record<string, string[]>;
  appliedProperties: Record<string, string[]>;
  appliedSort: string;
  appliedMinPrice: number;
  appliedMaxPrice: number;
  properties: PropertiesSettings[];
  tags: TagsSettings[];
  minPrice: number | undefined;
  maxPrice: number | undefined;
}

const FilteredItems = React.memo((props: Props) => {
  const {
    appliedTags,
    appliedProperties,
    appliedSort,
    appliedMinPrice,
    appliedMaxPrice,
    properties,
    tags,
    minPrice,
    maxPrice
  } = props

  const handlesApply = useCallback((
    paramsTags: Record<string, string[]> | null,
    paramsProperties: Record<string, string[]> | null,
    paramsSort: string | null,
    paramsMinPrice: number | null,
    paramsMaxPrice: number | null
  ) => {
    applyFilters({
      tags: paramsTags === null ? appliedTags : paramsTags,
      properties: paramsProperties === null ? appliedProperties : paramsProperties,
      sort: paramsSort === null ? appliedSort : paramsSort,
      minPrice: paramsMinPrice === null ? appliedMinPrice : paramsMinPrice,
      maxPrice: paramsMaxPrice === null ? appliedMaxPrice : paramsMaxPrice
    })
  }, [])

  return (
    <>
      {hasFilterApplied && (
        <div className="filtered-items-container">
          <FilteredTags
            appliedTags={appliedTags}
            tags={tags}
            handlesApply={handlesApply}
          />
          <FilteredProperties
            appliedProperties={appliedProperties}
            properties={properties}
            handlesApply={handlesApply}
          />
          {appliedSort && (
            <FilteredSort
              appliedSort={appliedSort}
              handlesApply={handlesApply}
            />
          )}
          <FilteredPrice
            appliedMinPrice={appliedMinPrice}
            appliedMaxPrice={appliedMaxPrice}
            minPrice={minPrice}
            maxPrice={maxPrice}
            handlesApply={handlesApply}
          />
        </div>
      )}
    </>
  )
})

FilteredItems.displayName = 'FilteredItems'

export default FilteredItems
